export default function extractTracklist(mixes, limit = 0) {
    return (mixes || [])
        .reduce((total, key, i) => {
            return [...total, ...mixes[i]['track_list']]
        }, [])
        .slice(0, limit)
}
